import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigation_select_channel } from '../../../redux/reducers/navigationSlice';
import HomeTemplateLink from './HomeTemplateLink';
import { HomeContentContainer, HomeContentWrapper, HomeContentLinks } from './HomeContent.styled';

function mapStateToProps(state, ownProps) {
   return {
      // SelectedChannel: state.navigation.selectedChannel,
      // SelectedGeography: state.navigation.selectedGeography,
      //isMobile: state.browser.lessThan.large,
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      selectChannel: (channel, isMobile) => {
         const params = {
            channel: channel,
            isMobile: isMobile
         };

         dispatch(navigation_select_channel(params));
      }
   };
};

class HomeContent extends Component<
   {
      isMobile: boolean;
      channelTitle: string;
      templateList: any[];
      active: boolean;
      selectChannel: any;
      SelectedChannel: string;
      SelectedGeography: string;
   },
   {}
> {
   constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
   }

   private onClick() {
      this.props.selectChannel(this.props.channelTitle, this.props.isMobile);
   }

   public render() {
      const { templateList, isMobile } = this.props;
      // TODO: most likely need to pull channel from state then loop over the links

      const collectionLinks = templateList.map((collection, index) => (
         <HomeTemplateLink key={index} name={collection.Name} id={collection.Id} templateid={collection.TId} />
      ));

      return (
         <HomeContentContainer isMobile={isMobile}>
            <HomeContentWrapper>
               <HomeContentLinks>{collectionLinks}</HomeContentLinks>
            </HomeContentWrapper>
         </HomeContentContainer>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContent);
